(function () {
  // Mobile menu
  var btn = document.querySelector('.menu-btn');
  var mob = document.getElementById('mobile-nav');
  if (btn && mob) {
    btn.addEventListener('click', function () {
      var open = mob.hidden;
      mob.hidden = !open;
      btn.setAttribute('aria-expanded', open);
      btn.textContent = open ? 'Close' : 'Menu';
    });
  }

  // Gallery filters and lightbox
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var grid = root.querySelector('.g-grid');
    var lb = root.querySelector('.lightbox');
    var li = lb && lb.querySelector('img');
    var lc = lb && lb.querySelector('p');
    root.querySelectorAll('.g-filters button').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.g-filters button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        var f = b.dataset.f;
        grid.querySelectorAll('button').forEach(function (t) { t.hidden = !(f === 'all' || t.dataset.cat === f); });
      });
    });
    if (!lb) return;
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      li.src = t.dataset.full;
      li.alt = t.dataset.alt;
      lc.textContent = t.dataset.alt;
      lb.hidden = false;
      lb.querySelector('.close').focus();
    });
    function close() { lb.hidden = true; }
    lb.querySelector('.close').addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });


  // Quote form spam guard: needs JS, a real interaction, an empty hidden field and at least 4 seconds on the page.
  document.querySelectorAll('form#quote-form').forEach(function (f) {
    var start = Date.now(), human = false;
    function markHuman() {
      human = true;
      var g = f.querySelector('input[data-guard]');
      if (g) g.name = 'form_type'; // restores Shopify's contact form (and its hCaptcha) for real visitors
    }
    ['pointerdown', 'keydown', 'touchstart', 'focusin'].forEach(function (ev) { f.addEventListener(ev, markHuman, { once: true, passive: true }); });
    f.addEventListener('submit', function (e) {
      var hp = f.querySelector('input[name="contact[website]"]');
      var tooFast = Date.now() - start < 4000;
      if (!human || (hp && hp.value)) { e.preventDefault(); return; }
      if (tooFast) {
        // A real person who fills the form very quickly: hold briefly, then send.
        e.preventDefault();
        var btn = f.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
        setTimeout(function () { if (btn) btn.disabled = false; f.requestSubmit ? f.requestSubmit(btn) : f.submit(); }, 4000 - (Date.now() - start));
        return;
      }
      if (hp) hp.parentNode.removeChild(hp);
    });
  });

  // Bring the thank-you panel into view after a quote is sent
  var done = document.getElementById('quote-done');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }

  // Before and after slider
  document.querySelectorAll('.ba-frame').forEach(function (f) {
    var r = f.querySelector('input');
    r.addEventListener('input', function () { f.style.setProperty('--pos', r.value + '%'); });
  });
})();
